import React from 'react'

import { Box, Color } from '@gousto-internal/citrus-react'

export const Divider = () => (
  <Box paddingV={4} data-testid="Divider">
    <Box width="100%" height="0.0625rem" bg={Color.ColdGrey_100} />
  </Box>
)
